// import './appState';
const $495153d3042d31f4$var$getEdgeCellState = (edges, isLeft, state)=>{
    if (edges === "dead") return 0;
    else if (edges === "alive") return 1;
    else if (edges === "random") return Math.round(Math.random());
    else if (edges === "loop") return isLeft ? state[state.length - 1] : state[0];
    else return Math.round(Math.random());
};
function $495153d3042d31f4$var$drawGeneration(state, i, ctx, pixelSize, color) {
    ctx.fillStyle = color;
    const y = i * pixelSize;
    for(let j = 0; j < state.length; j++)if (state[j]) ctx.fillRect(j * pixelSize, y, pixelSize, pixelSize);
}
function $495153d3042d31f4$var$updateState(prevState, ruleNumber, edges) {
    const nextState = [];
    for(let j = 0; j < prevState.length; j++){
        const left = j === 0 ? $495153d3042d31f4$var$getEdgeCellState(edges, true, prevState) : prevState[j - 1] || 0;
        const center = prevState[j];
        const right = j === prevState.length - 1 ? $495153d3042d31f4$var$getEdgeCellState(edges, false, prevState) : prevState[j + 1] || 0;
        const rule = (left << 2) + (center << 1) + right; // 0-7
        const newStateBit = (ruleNumber >> rule) % 2;
        nextState.push(newStateBit);
    }
    return nextState;
}
function $495153d3042d31f4$export$9cd052364f19d26c({ ctx: ctx, width: width, height: height, pixelSize: pixelSize, mainColor: mainColor, backgroundColor: backgroundColor, initialState: initialState, ruleNumber: ruleNumber, edges: edges }) {
    ctx.fillStyle = backgroundColor;
    ctx.fillRect(0, 0, width, height);
    let state = initialState;
    for(let i = 0; i < height / pixelSize; i++){
        $495153d3042d31f4$var$drawGeneration(state, i, ctx, pixelSize, mainColor);
        state = $495153d3042d31f4$var$updateState(state, ruleNumber, edges);
    }
}


const $2fc1dd3758c248df$export$53ac33307b5acee9 = (size, density)=>{
    const state = new Array(size).fill(0).map(()=>Math.random() < density ? 1 : 0);
    if (density === 0) state[Math.floor(size / 2)] = 1;
    return state;
};


const $8101dc87bd501ba1$export$c4fe9b17d4c0d790 = document.getElementById("width");
const $8101dc87bd501ba1$export$8bfc9d91392fae00 = document.getElementById("height");
const $8101dc87bd501ba1$export$3717e99d9bcf21cc = document.getElementById("rule");
const $8101dc87bd501ba1$export$9e1e87aa131fefc5 = document.getElementById("edges");
const $8101dc87bd501ba1$export$83566e52469fe200 = document.getElementById("pixelsize");
const $8101dc87bd501ba1$export$6585c1bf5dd771e8 = document.getElementById("color");
const $8101dc87bd501ba1$export$5e532b2df0657b8e = document.getElementById("background");
const $8101dc87bd501ba1$export$879334de689bbfd5 = document.getElementById("density");
const $8101dc87bd501ba1$export$6210fa4921d2a466 = document.getElementById("form");
const $8101dc87bd501ba1$var$canvasEl = document.getElementById("canvas");
const $8101dc87bd501ba1$var$ctx = $8101dc87bd501ba1$var$canvasEl.getContext("2d");
function $8101dc87bd501ba1$export$3855fd213a39a375({ width: width, height: height, ruleNumber: ruleNumber, edges: edges, pixelSize: pixelSize, mainColor: mainColor, backgroundColor: backgroundColor, density: density }) {
    $8101dc87bd501ba1$export$c4fe9b17d4c0d790.value = width.toString();
    $8101dc87bd501ba1$export$8bfc9d91392fae00.value = height.toString();
    $8101dc87bd501ba1$export$3717e99d9bcf21cc.value = ruleNumber.toString();
    $8101dc87bd501ba1$export$9e1e87aa131fefc5.value = edges;
    $8101dc87bd501ba1$export$83566e52469fe200.value = pixelSize.toString();
    $8101dc87bd501ba1$export$6585c1bf5dd771e8.value = mainColor;
    $8101dc87bd501ba1$export$5e532b2df0657b8e.value = backgroundColor;
    $8101dc87bd501ba1$export$879334de689bbfd5.value = density.toString();
}
function $8101dc87bd501ba1$export$80d376111cc09ad7() {
    const timer = performance.now();
    const width = parseInt($8101dc87bd501ba1$export$c4fe9b17d4c0d790.value);
    const height = parseInt($8101dc87bd501ba1$export$8bfc9d91392fae00.value);
    const pixelSize = parseInt($8101dc87bd501ba1$export$83566e52469fe200.value);
    $8101dc87bd501ba1$var$canvasEl.width = width;
    $8101dc87bd501ba1$var$canvasEl.height = height;
    const ruleNumber = parseInt($8101dc87bd501ba1$export$3717e99d9bcf21cc.value, 10);
    (0, $495153d3042d31f4$export$9cd052364f19d26c)({
        ctx: $8101dc87bd501ba1$var$ctx,
        width: width,
        height: height,
        pixelSize: pixelSize,
        mainColor: $8101dc87bd501ba1$export$6585c1bf5dd771e8.value,
        backgroundColor: $8101dc87bd501ba1$export$5e532b2df0657b8e.value,
        initialState: (0, $2fc1dd3758c248df$export$53ac33307b5acee9)(Math.ceil(width / pixelSize), parseFloat($8101dc87bd501ba1$export$879334de689bbfd5.value)),
        ruleNumber: ruleNumber,
        edges: $8101dc87bd501ba1$export$9e1e87aa131fefc5.value,
        density: parseFloat($8101dc87bd501ba1$export$879334de689bbfd5.value)
    });
    document.getElementById("running-time").innerHTML = `Generated in ${performance.now() - timer}ms`;
}
$8101dc87bd501ba1$export$6210fa4921d2a466.addEventListener("change", $8101dc87bd501ba1$export$80d376111cc09ad7);
$8101dc87bd501ba1$export$6210fa4921d2a466.addEventListener("submit", (e)=>{
    e.preventDefault();
    $8101dc87bd501ba1$export$80d376111cc09ad7();
});


const $f447ff950dd7b967$var$colors = [
    "#000000",
    "#FFFFFF",
    "#FF0000",
    "#00FF00",
    "#0000FF",
    "#FFFF00",
    "#00FFFF",
    "#FF00FF",
    "#FF8000",
    "#FF0080"
];
const $f447ff950dd7b967$var$DENSITY_STEP = 0.05;
document.addEventListener("keydown", (e)=>{
    if (e.target !== document.body) return;
    switch(e.code){
        // Density
        case "ArrowDown":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$879334de689bbfd5).value = (parseFloat((0, $8101dc87bd501ba1$export$879334de689bbfd5).value) - $f447ff950dd7b967$var$DENSITY_STEP).toString();
            break;
        case "ArrowUp":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$879334de689bbfd5).value = (parseFloat((0, $8101dc87bd501ba1$export$879334de689bbfd5).value) + $f447ff950dd7b967$var$DENSITY_STEP).toString();
            break;
        // Rule
        case "ArrowLeft":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$3717e99d9bcf21cc).value = Math.max(parseInt((0, $8101dc87bd501ba1$export$3717e99d9bcf21cc).value, 10) - 1, 0).toString(10);
            break;
        case "ArrowRight":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$3717e99d9bcf21cc).value = Math.min(255, parseInt((0, $8101dc87bd501ba1$export$3717e99d9bcf21cc).value, 10) + 1).toString(10);
            break;
        // Edges
        case "Slash":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$9e1e87aa131fefc5).value = "loop";
            break;
        case "Period":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$9e1e87aa131fefc5).value = "alive";
            break;
        case "Comma":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$9e1e87aa131fefc5).value = "dead";
            break;
        // Pixel size
        case "Equal":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$83566e52469fe200).value = Math.min(parseInt((0, $8101dc87bd501ba1$export$83566e52469fe200).max), parseInt((0, $8101dc87bd501ba1$export$83566e52469fe200).value, 10) * 2).toString(10);
            break;
        case "Minus":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$83566e52469fe200).value = Math.max(parseInt((0, $8101dc87bd501ba1$export$83566e52469fe200).min), parseInt((0, $8101dc87bd501ba1$export$83566e52469fe200).value, 10) / 2).toString(10);
            break;
        // Color
        case "KeyA":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$6585c1bf5dd771e8).value = $f447ff950dd7b967$var$colors[0];
            break;
        case "KeyS":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$6585c1bf5dd771e8).value = $f447ff950dd7b967$var$colors[1];
            break;
        case "KeyD":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$6585c1bf5dd771e8).value = $f447ff950dd7b967$var$colors[2];
            break;
        case "KeyF":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$6585c1bf5dd771e8).value = $f447ff950dd7b967$var$colors[3];
            break;
        case "KeyG":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$6585c1bf5dd771e8).value = $f447ff950dd7b967$var$colors[4];
            break;
        case "KeyH":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$6585c1bf5dd771e8).value = $f447ff950dd7b967$var$colors[5];
            break;
        case "KeyJ":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$6585c1bf5dd771e8).value = $f447ff950dd7b967$var$colors[6];
            break;
        case "KeyK":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$6585c1bf5dd771e8).value = $f447ff950dd7b967$var$colors[7];
            break;
        case "KeyL":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$6585c1bf5dd771e8).value = $f447ff950dd7b967$var$colors[8];
            break;
        // Background
        case "KeyZ":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$5e532b2df0657b8e).value = $f447ff950dd7b967$var$colors[0];
            break;
        case "KeyX":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$5e532b2df0657b8e).value = $f447ff950dd7b967$var$colors[1];
            break;
        case "KeyC":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$5e532b2df0657b8e).value = $f447ff950dd7b967$var$colors[2];
            break;
        case "KeyV":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$5e532b2df0657b8e).value = $f447ff950dd7b967$var$colors[3];
            break;
        case "KeyB":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$5e532b2df0657b8e).value = $f447ff950dd7b967$var$colors[4];
            break;
        case "KeyN":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$5e532b2df0657b8e).value = $f447ff950dd7b967$var$colors[5];
            break;
        case "KeyM":
            e.preventDefault();
            (0, $8101dc87bd501ba1$export$5e532b2df0657b8e).value = $f447ff950dd7b967$var$colors[6];
            break;
    }
    (0, $8101dc87bd501ba1$export$80d376111cc09ad7)();
    console.log({
        key: e.key,
        code: e.code,
        keyCode: e.keyCode,
        shift: e.shiftKey,
        ctrl: e.ctrlKey
    });
});



(0, $8101dc87bd501ba1$export$80d376111cc09ad7)();


//# sourceMappingURL=index.a5baa021.js.map
